export default import.meta.ROLLDOWN_FILE_URL_QwsodWPva8u3GCl98ABbXQ